
export default {
  props: {
    type: {
      type: String,
      default: 'info',
      validator(value) {
        return ['error', 'warning', 'success', 'info'].includes(value)
      }
    }
  },
  computed: {
    type_class() {
      return `alert-${this.type}`
    }
  }
}
